<template>
  <el-select
    :clearable="clearable"
    :disabled="disabled"
    filterable
    :value="value"
    @change="changeHandle"
  >
    <el-option
      v-for="(item, index) in serviceTypeLists[ServiceType]"
      :key="index"
      :value="item.id"
      :label="item.serviceName"
    ></el-option>
  </el-select>
</template>

<script>
import serviceTypeMixin from './mixin.js';

export default {
  name: 'service-select',
  props: {
    size: {
      type: String,
      default: '',
    },
    value: {
      type: Number,
      default: null,
    },
    disabled: Boolean,
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [serviceTypeMixin],
  methods: {
    changeHandle(val) {
      if (val || val === 0) {
        this.$emit('input', val);
        this.$emit('change', val);
      } else {
        this.$emit('input', null);
        this.$emit('change', null);
      }
    },
  },
};
</script>

